import React from 'react';
import Layout from '../Maker.layout';
import { useOption, worksheetActions } from '@src/stores/worksheet.store';
import ToggleSwitch from '@src/components/UI/Switch';
import { useIsAdmin, useUserIsEmail } from '@src/hooks/user';

const Wrapper = ({ children }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 10,
      }}
    >
      {children}
    </div>
  );
};

const Options = () => {
  // categories
  const qualification = useOption('qualification');
  const area = useOption('area');
  const subtopic = useOption('subtopic');
  const difficulty = useOption('difficulty');
  const series = useOption('series');
  const paper = useOption('paper');
  const questionNumber = useOption('question_number');

  // qr code options
  const questionMsQR = useOption('questionMsQR');
  const questionWrittenMsQR = useOption('questionWrittenMsQR');
  const writtenMsQR = useOption('writtenMsQR');

  // misc
  const markSchemePDF = useOption('markSchemePDF');
  const incrementQuestions = useOption('incrementQuestions');
  const orderByDifficulty = useOption('orderByDifficulty');

  const isAdmin = useIsAdmin();

  const isEmail = useUserIsEmail([
    'lilylysik@gmail.com',
    'lollyla286@gmail.com',
    'james+duo@2b.co.uk',
  ]);

  const canAccessAdmin = isAdmin || isEmail;

  return (
    <Layout>
      <div>
        <h4>Question PDF</h4>
        <hr />

        <p>
          <strong>Categories</strong>
        </p>

        <Wrapper>
          <p>Qualification</p>
          <ToggleSwitch
            id="qualification"
            checked={qualification}
            onChange={() => worksheetActions.toggleOption('qualification')}
          />
        </Wrapper>

        <Wrapper>
          <p>Area(s)</p>
          <ToggleSwitch
            id="area"
            checked={area}
            onChange={() => worksheetActions.toggleOption('area')}
          />
        </Wrapper>

        <Wrapper>
          <p>Subtopic(s)</p>
          <ToggleSwitch
            id="subtopic"
            checked={subtopic}
            onChange={() => worksheetActions.toggleOption('subtopic')}
          />
        </Wrapper>

        <Wrapper>
          <p>Difficulty</p>
          <ToggleSwitch
            id="difficulty"
            checked={difficulty}
            onChange={() => worksheetActions.toggleOption('difficulty')}
          />
        </Wrapper>

        <Wrapper>
          <p>Series</p>
          <ToggleSwitch
            id="series"
            checked={series}
            onChange={() => worksheetActions.toggleOption('series')}
          />
        </Wrapper>

        <Wrapper>
          <p>Paper</p>
          <ToggleSwitch
            id="paper"
            checked={paper}
            onChange={() => worksheetActions.toggleOption('paper')}
          />
        </Wrapper>

        <Wrapper>
          <p>Question Numbers</p>
          <ToggleSwitch
            id="question_number"
            checked={questionNumber}
            onChange={() => worksheetActions.toggleOption('question_number')}
          />
        </Wrapper>

        <Wrapper>
          <p>Order By Difficulty</p>
          <ToggleSwitch
            id="orderByDifficulty"
            checked={orderByDifficulty}
            onChange={() => worksheetActions.toggleOption('orderByDifficulty')}
          />
        </Wrapper>
      </div>

      <div>
        <p>
          <strong>QR Codes</strong>
        </p>

        <Wrapper>
          <p>Include Mark Scheme</p>
          <ToggleSwitch
            id="questionMsQR"
            checked={questionMsQR}
            onChange={() => worksheetActions.toggleOption('questionMsQR')}
          />
        </Wrapper>

        <Wrapper>
          <p>Include Written MS</p>
          <ToggleSwitch
            id="questionWrittenMsQR"
            checked={questionWrittenMsQR}
            onChange={() => worksheetActions.toggleOption('questionWrittenMsQR')}
          />
        </Wrapper>
      </div>

      <div>
        <h4>Mark Scheme Pdf</h4>
        <hr />

        <Wrapper>
          <p>Include Separate Mark Scheme PDF</p>
          <ToggleSwitch
            id="markSchemePDF"
            checked={markSchemePDF}
            onChange={() => worksheetActions.toggleOption('markSchemePDF')}
          />
        </Wrapper>

        <Wrapper>
          <p>Include Written MS QR Code</p>
          <ToggleSwitch
            id="writtenMsQR"
            checked={writtenMsQR}
            onChange={() => worksheetActions.toggleOption('writtenMsQR')}
          />
        </Wrapper>
      </div>

      {canAccessAdmin && (
        <div>
          <h4>Admin</h4>
          <hr />

          <Wrapper>
            <p>Show Question Numbers</p>
            <ToggleSwitch
              id="incrementQuestions"
              checked={incrementQuestions}
              onChange={() => worksheetActions.toggleOption('incrementQuestions')}
            />
          </Wrapper>
        </div>
      )}
    </Layout>
  );
};

export default Options;
